import React, { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Suggestions() {
    const [name, setName] = useState("");
    const [idea, setIdea] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!idea.trim()) {
            toast.error("Bitte teile uns deine Idee mit.");
            return;
        }
        setSubmitting(true);
        setTimeout(() => {
            toast.success(
                "Vielen Dank, deine Idee bedeutet uns viel ✦",
            );
            setName("");
            setIdea("");
            setSubmitting(false);
        }, 600);
    };

    return (
        <section
            id="ideen"
            data-testid="suggestions-section"
            className="relative py-24 md:py-32 bg-cream-50"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-16 items-start">
                <div className="md:col-span-5 reveal">
                    <span className="divider-dot mb-8">
                        <span>Mitgestalten</span>
                    </span>

                    <div className="flex items-start gap-4 mb-6">
                        <Sparkles
                            size={28}
                            className="text-mauve-500 mt-2 shrink-0"
                            strokeWidth={1.2}
                        />
                        <h2
                            className="font-serif font-light text-4xl sm:text-5xl text-ink-900 tracking-tight leading-[1.05]"
                            data-testid="suggestions-heading"
                        >
                            Teile deine
                            <br />
                            <em className="italic text-mauve-500">
                                Wünsche und Ideen.
                            </em>
                        </h2>
                    </div>

                    <p className="text-base md:text-lg text-ink-700 leading-relaxed font-light max-w-md">
                        Welches Notizbuch wünschst du dir? Welche Geschenke
                        sollten in unserer kleinen Welt nicht fehlen? Schreib
                        uns — jeder Gedanke ist willkommen.
                    </p>
                </div>

                <form
                    action="https://formspree.io/f/xkoyvrvv"
                    method="POST"
                    data-testid="suggestions-form"
                    className="md:col-span-7 reveal space-y-8"
                >
                    <div>
                        <label
                            htmlFor="suggest-name"
                            className="block text-[11px] tracking-[0.28em] uppercase text-ink-500 mb-3 font-light"
                        >
                            Name (optional)
                        </label>
                        <input
                            name="name"
                            id="suggest-name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Wie heißt du?"
                            data-testid="suggestions-name-input"
                            className="w-full bg-transparent border-b border-ink-700/25 focus:border-mauve-500 outline-none px-0 py-3 text-base text-ink-900 placeholder:text-ink-500 font-light transition-colors"
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="suggest-idea"
                            className="block text-[11px] tracking-[0.28em] uppercase text-ink-500 mb-3 font-light"
                        >
                            Deine Idee oder dein Wunsch
                        </label>
                        <textarea
                            name="message"
                            id="suggest-idea"
                            rows={5}
                            value={idea}
                            onChange={(e) => setIdea(e.target.value)}
                            placeholder="Erzähl uns davon…"
                            data-testid="suggestions-idea-input"
                            required
                            className="w-full bg-transparent border-b border-ink-700/25 focus:border-mauve-500 outline-none px-0 py-3 text-base text-ink-900 placeholder:text-ink-500 font-light resize-none transition-colors"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="suggestions-submit-button"
                        className="border border-ink-900 text-ink-900 hover:bg-ink-900 hover:text-cream-50 transition-colors px-10 py-4 text-xs tracking-[0.28em] uppercase font-light disabled:opacity-60"
                    >
                        {submitting ? "Sende…" : "Idee senden"}
                    </button>
                </form>
            </div>
        </section>
    );
}
